import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { IconUpload, IconBoxMultiple, IconDownload } from '@tabler/icons-react';

interface Props {
	title: string;
	description: string;
	labelText: string;
	acceptedFilesText: string;
	acceptedFileTypes: string[];
	singleFile?: boolean;
	onDrop: (event: React.DragEvent<HTMLDivElement> | React.ChangeEvent<HTMLInputElement>) => void;
	additionalButtonHandler?: () => void;
	additionalButtonText?: string;
}

export const UploadFiles = ({
	title,
	description,
	labelText,
	acceptedFilesText,
	acceptedFileTypes,
	singleFile = false,
	onDrop,
	additionalButtonHandler,
	additionalButtonText,
}: Props) => {
	return (
		<div className="bg-white border max-w-[608px] border-gray-300 border-solid rounded-lg mt-6 py-3 px-2 text-sm">
			<div className="text-gray-500">{title}</div>
			<div
				className="border border-dotted border-gray-500 rounded p-4 mt-2"
				onDrop={onDrop}
				onDragOver={(e) => e.preventDefault()}
			>
				<IconUpload className="text-blue-500" />
				<div className="font-semibold">{description}</div>
				<div className="my-2">{acceptedFilesText}</div>
				<div className="flex items-start">
					<label
						htmlFor="file-upload"
						className="bg-blue-700 font-semibold text-white flex justify-center items-center self-start p-2 rounded cursor-pointer"
					>
						{labelText}
						<IconBoxMultiple className="ml-2" />
						<input
							id="file-upload"
							type="file"
							accept={acceptedFileTypes.join(',')}
							multiple={!singleFile}
							onChange={onDrop}
							className="hidden"
						/>
					</label>
					{additionalButtonHandler && additionalButtonText && (
						<div
							data-testid={TEST_ELEMENT_IDS.DRAG_AND_DROP_TEMPLATE_DOWNLOAD_BUTTON}
							className="ml-4 bg-blue-700 font-semibold text-white flex justify-center items-center self-start p-2 rounded cursor-pointer"
							onClick={additionalButtonHandler}
						>
							{additionalButtonText}
							<IconDownload className="ml-2" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
